import React from 'react'

import LABEL from '../../business-const/Label/Label'

import {
    IconButtonVideoTrilhaConhecimento,
} from '../IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../Dialog/CustomizeDialogs'

import VideoForm from '../../views/videos/video-form/VideoForm'



export const CustomizedDialogsVideo = ( {idFuncionalidade} ) => {

    return (
        idFuncionalidade && !idFuncionalidade
            ?
                <CustomizedDialogsPopup
                    maxWidth='lg'
                    align='center'
                    popupTitle={LABEL.trilhaConhecimento}
                    PopupButton={IconButtonVideoTrilhaConhecimento}
                    popupComponent={
                        <VideoForm
                            idFuncionalidade={idFuncionalidade}
                        />
                    }
                />
            :
                ''
    )
}